export default "__VITE_ASSET__Cz45gfqh__"